// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/rocket.js';

import { paths } from '../generated/rocket';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('rocket', Original, paths);
